import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const a11yProps = index => ({
  id: `scrollable-auto-tab-${index}`,
  key: `scrollable-auto-tab-${index}`,
  'aria-controls': `scrollable-auto-tabpanel-${index}`
});

const ResourceHistoryTabBar = ({ value, handleChange }) => {
  return (
    <AppBar position="static" color="default">
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        <Tab label="Resources" {...a11yProps(0)} />
        <Tab label="Requests" {...a11yProps(1)} />
        <Tab label="Experiences" {...a11yProps(2)} />
      </Tabs>
    </AppBar>
  );
};

export default ResourceHistoryTabBar;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/ResourceHistory/TabBar.js